import api from '@/lib/axios';
import { API_ENDPOINTS } from '@/constants/api-endpoints';
import type { LoginRequest, LoginResponse } from '@/types/api.types';

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await api.post<LoginResponse>(API_ENDPOINTS.AUTH.LOGIN, data);
    return response.data;
  },

  logout: async (): Promise<void> => {
    await api.post(API_ENDPOINTS.AUTH.LOGOUT);
  },

  refreshToken: async (refreshToken: string): Promise<{ accessToken: string; refreshToken: string }> => {
    const response = await api.post(API_ENDPOINTS.AUTH.REFRESH, { refreshToken });
    return response.data;
  },

  forgotPassword: async (email: string): Promise<void> => {
    await api.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { email });
  },

  verifyResetOtp: async (email: string, otp: string): Promise<{ data: { reset_token: string } }> => {
    const response = await api.post(API_ENDPOINTS.AUTH.VERIFY_RESET_OTP, { email, otp });
    return response.data;
  },

  resetPassword: async (token: string, password: string): Promise<void> => {
    await api.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { token, password });
  },

  getProfile: async () => {
    const response = await api.get(API_ENDPOINTS.AUTH.PROFILE);
    return response.data;
  },
};
